module.exports = {
          srcSet: __webpack_public_path__ + "public/ed16b0ba280318fb869a43a2e2ed992d-80.png"+" 80w",
          images:[ {path: __webpack_public_path__ + "public/ed16b0ba280318fb869a43a2e2ed992d-80.png",width: 80,height: 80}],
          src: __webpack_public_path__ + "public/ed16b0ba280318fb869a43a2e2ed992d-80.png",
          toString:function(){return __webpack_public_path__ + "public/ed16b0ba280318fb869a43a2e2ed992d-80.png"},
          
          width: 80,
          height: 80
        }